import { BaseElement } from '../../../base-element';
import type { EntrySummaryDto } from '../../../../api/types';
import './entry-row';

type EntryRowElement = HTMLElement & {
  entry: EntrySummaryDto;
};

export class EntryTable extends BaseElement {
  private _entries: EntrySummaryDto[] = [];

  get entries(): EntrySummaryDto[] {
    return this._entries;
  }

  set entries(value: EntrySummaryDto[]) {
    this._entries = value;
    if (this.isConnected) {
      this.updateRender();
    }
  }

  connectedCallback(): void {
    this.updateRender();
  }

  private updateRender(): void {
    this.render(`
      <div class="overflow-hidden rounded-2xl border border-neutral-200 bg-white" data-testid="entry-table">
        <div class="grid grid-cols-1 gap-3 border-b border-neutral-200 bg-neutral-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-neutral-500 sm:grid-cols-6 sm:gap-4">
          <div>Entry #</div>
          <div>Handler</div>
          <div>Dog</div>
          <div>Status</div>
          <div>PDF Status</div>
          <div>Date</div>
        </div>
        <div class="divide-y divide-neutral-200">
          ${this._entries.map((entry) => `<dt-entry-row data-entry-id="${entry.entryId}"></dt-entry-row>`).join('')}
        </div>
      </div>
    `);

    const rows = this.$$('dt-entry-row') as NodeListOf<EntryRowElement>;
    rows.forEach((row, index) => {
      const entry = this._entries[index];
      if (entry) {
        row.entry = entry;
      }
    });
  }
}

customElements.define('dt-entry-table', EntryTable);
